import CustomIcon from "../icon";
import '../../App.css'; // Import your fonts

export default function Chip({
    label = "Label",
    size = "small",
    alert = false,
    iconName,
    icon,
    iconPosition = "right"
}) {
    const sizeOptions = {
        small: { maxChars: 28, fontSize: 13, adjustment: .6 },
        medium: { maxChars: 40, fontSize: 18, adjustment: .7 },
        large: { maxChars: 60, fontSize: 20, adjustment: .8 },
    };
    let { maxChars, fontSize, adjustment } = sizeOptions[size] || sizeOptions['small'];
    const iconHeight = fontSize + 6;

    const borderColor = alert ?
        '#FF6D2A'
        : 
        '#009C49'

    const backgroundColor = alert ?
        '#FEF8F2'
        : 
        '#DCFFEC'

    const iconLineColor = alert ?
    '#FF6D2A'
    : 
    '#00A54C'

    const isSingleWord = label.trim().split(/\s+/).length === 1;

    const singleWordStyle = {
        color: iconLineColor,
        fontSize: fontSize,
        lineHeight:'15px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth:'80%',
        display: 'block',
        textAlign:'center',
        marginLeft: '5px',
        marginRight: iconPosition === 'right' ? '5px' : 0,
    };

    const multiWordStyle = {
        color: iconLineColor,
        fontSize: fontSize,
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        wordBreak: 'break-word',
        lineHeight:'15px',
        maxHeight: '2.4em',
        maxWidth:'100%',
        textAlign:'center',
    };

    const customButtonStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: '1px',
        backgroundColor: backgroundColor,
        borderStyle: 'solid',
        borderColor: borderColor,
        width: size === 'large' ? '500px' : size === 'medium' ? '300px' : '132px',
        padding: '8px 16px 8px 16px',
        borderRadius: '24px',
        height: '20px'
    };
    const buttonLabelStyle = isSingleWord ? singleWordStyle : multiWordStyle;

    return (
        <div
            style={customButtonStyle}
        >
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            }}>
                {icon ? iconPosition === 'left' &&
                    icon
                    : null
                }
                {iconName ? iconPosition === 'left' &&
                    <CustomIcon
                        name={iconName}
                        size={iconHeight}
                        color={iconLineColor}
                    />
                    : null
                }
                {label ?
                    <div className = "buttonLargeBold"
                        style={buttonLabelStyle}
                    >
                        {label}
                    </div>
                    : null
                }
                {icon ? iconPosition === 'right' &&
                    icon
                    : null
                }
                {iconName ? iconPosition === 'right' &&
                    <CustomIcon
                        name={iconName}
                        size={iconHeight}
                        color={iconLineColor}
                    />
                    : null
                }
            </div>
        </div>
    );
};